import { UniversalProvider } from '@walletconnect/universal-provider';
import {} from 'viem';
import {} from '@reown/appkit-common';
import { CoreHelperUtil, WcHelpersUtil } from '@reown/appkit-controllers';
import { ConstantsUtil, PresetsUtil } from '@reown/appkit-utils';
export async function getWalletConnectCaipNetworks(connector) {
    if (!connector) {
        throw new Error('WagmiAdapter:getApprovedCaipNetworks - connector is undefined');
    }
    const provider = (await connector?.getProvider());
    const approvedCaipNetworkIds = WcHelpersUtil.getChainsFromNamespaces(provider?.session?.namespaces);
    return {
        supportsAllNetworks: false,
        approvedCaipNetworkIds
    };
}
export function getEmailCaipNetworks() {
    return {
        supportsAllNetworks: true,
        approvedCaipNetworkIds: PresetsUtil.WalletConnectRpcChainIds.map(id => `${ConstantsUtil.EIP155}:${id}`)
    };
}
export function requireCaipAddress(caipAddress) {
    if (!caipAddress) {
        throw new Error('No CAIP address provided');
    }
    const account = caipAddress.split(':')[2];
    if (!account) {
        throw new Error('Invalid CAIP address');
    }
    return account;
}
export function parseWalletCapabilities(str) {
    try {
        return JSON.parse(str);
    }
    catch (error) {
        throw new Error('Error parsing wallet capabilities');
    }
}
export async function getSafeConnector(connectors) {
    if (CoreHelperUtil.isSafeApp()) {
        const { safe } = await import('@wagmi/connectors');
        if (safe && !connectors.some(c => c.type === 'safe')) {
            const safeConnector = safe();
            return safeConnector;
        }
    }
    return null;
}
export async function getBaseAccountConnector(connectors) {
    try {
        const { baseAccount } = await import('@wagmi/connectors');
        if (baseAccount && !connectors.some(c => c.id === 'baseAccount')) {
            return baseAccount();
        }
    }
    catch (error) {
        console.error('Failed to import Coinbase Wallet SDK:', error);
    }
    return null;
}
//# sourceMappingURL=helpers.js.map